module.exports = __webpack_public_path__ + "b01fcca1198b968c19ad8cee5cb5b8ff.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/icons/icon-engagement.png
// module id = 3213
// module chunks = 69